<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
<template>
  <div class="creatAutograph-box" >
    <div class="shade-box">
      <div class="shade-content shade-width">
        <p class="dialog-title-bg">{{title}}签名
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetAutographForm('creatAutographForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="creatForm" :rules="$rules" ref="creatAutographForm" label-width="130px" class="demo-ruleForm">
            <el-row>
              <el-col :span="11">
                <el-form-item label="是否对下级公用" prop="isPublic" >
                  <el-radio-group v-model="creatForm.isPublic" >
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签名用途" prop="usedMethod" >
                  <el-radio-group v-model="creatForm.usedMethod" >
                    <el-radio :label="0">自用</el-radio>
                    <el-radio :label="1">他用</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                 <el-form-item label="签名类型" prop="signType" >
                  <el-select v-model="creatForm.signType" placeholder="请选择" >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否公用" prop="signatureType" >
                  <el-radio-group v-model="creatForm.signatureType" >
                    <el-radio :label="0">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="签名名称" prop="signName">
              <el-input v-model="creatForm.signName" placeholder="请输入公司名的全称或简称" ref="signNameUnput"></el-input>
            </el-form-item>
            <el-form-item>
              <p class="colorBBB">长度为2~12个字，由中英文、数字组成，内容不包含【】。  </p>
            </el-form-item>
            <el-form-item label="企业名称" prop="enterpriseName" >
              <el-input v-model="creatForm.enterpriseName" placeholder="请输入企业名称" ref="signNameUnput"></el-input>
            </el-form-item>
            <el-form-item label="证明类型" prop="documentType" >
              <el-select v-model="creatForm.documentType" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-col :span="10">
                <el-form-item label="证明上传" required >
                  <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    action="http(s)://upload-z2.qiniup.com"
                    :show-file-list="false"
                    :http-request="uploadQiniu1"
                    :before-upload="beforeUpload"
                    :auto-upload="true"
                    :multiple='false'
                    :on-change="handleChange"
                    accept="image/jpg,image/png">
                    <img v-if="picUrl" :src="picUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <!--<i class="el-icon-upload"></i>-->
                    <!--<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
                    <!--<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过5MB</div>-->
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <p class="colorBBB">只能上传jpg/png文件，且不超过5MB </p>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="授权委托" required  v-if="creatForm.usedMethod == '1'">
                  <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    action="http(s)://upload-z2.qiniup.com"
                    :show-file-list="false"
                    :http-request="uploadQiniu2"
                    :before-upload="beforeUpload"
                    :auto-upload="true"
                    :multiple='false'
                    :on-change="handleChange"
                    accept="image/jpg,image/png">
                    <img v-if="commissionImage" :src="commissionImage" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <!--<i class="el-icon-upload"></i>-->
                    <!--<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
                    <!--<div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过5MB</div>-->
                  </el-upload>
                </el-form-item>
                <el-form-item v-if="creatForm.usedMethod == '1'">
                  <p class="colorBBB">只能上传jpg/png文件，且不超过5MB </p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="申请说明" prop="signReason">
              <el-input type="textarea" v-model="creatForm.signReason" placeholder="请输入签名申请用途" :autosize="{ minRows: 3, maxRows: 5}" resize='none'></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('creatAutographForm')" :disabled="disabled">立即{{title}}</el-button>
              <el-button @click="resetAutographForm('creatAutographForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
import axios from 'axios'
export default {
  props: {
    data:{
      type: Object
    }
  },
  name: "creatAutograph",
  data(){
    return{
      options:[
        {
          "value":"0",
          "label":"公司"
        },
        {
          "value":"1",
          "label":"APP"
        },
        {
          "value":"2",
          "label":"网站"
        },
        {
          "value":"3",
          "label":"公众号或者小程序"
        },
        {
          "value":"4",
          "label":"商标"
        },
        {
          "value":"5",
          "label":"政府/机关事业单位/其他机构"
        }
      ],
      options1:[
        {
          "value":"0",
          "label":"三证合一"
        },
        {
          "value":"1",
          "label":"企业营业执照"
        },
        {
          "value":"2",
          "label":"组织机构代码证书"
        },
        {
          "value":"3",
          "label":"社会信用代码证书"
        },
        {
          "value":"4",
          "label":"应用后台管理截图"
        },
        {
          "value":"5",
          "label":"网站备案后台截图"
        },
        {
          "value":"6",
          "label":"小程序设置页面截图"
        },
        {
          "value":"7",
          "label":"商标注册书"
        }
      ],
      disabled: false,
      loadProgress1: 0, // 动态显示进度条
      progressFlag1: false, // 关闭进度条
      loadProgress2: 0, // 动态显示进度条
      progressFlag2: false, // 关闭进度条
      title: '创建',
      picUrl: '',
      usedMethod: '',
      documentType:'',
      commissionImage:'',
      enterpriseName:'',
      signatureType:'',
      isPublic:'',
      creatForm: {
        usedMethod:'',
        documentType:'',
        signType: '',
        signName: '',
        signReason: '',
        commissionImage: '',
        enterpriseName:'',
        signatureType:'',
        isPublic:''
      },
    };
    
  },
  created(){
    if(this.data){
      this.creatForm = this.data;
      console.info(this.data)
      this.picUrl = this.data.signPicUrl;
      this.creatForm.signType = this.data.signType+"";
      this.creatForm.documentType = this.data.documentType+"";
      this.commissionImage = this.data.commissionImage;
      this.title = '修改';
    }else{
      this.$nextTick(function(){
        this.creatForm.usedMethod = 0 ,
        this.creatForm.isPublic = 1 ,
        this.creatForm.signatureType = 1 ,
        this.$refs.signNameUnput.focus();
      })
    }
  },
  methods: {
    uploadQiniu1(file){
      let data = {
        "type": 7,
        "fileName": new Date().getTime() + file.file.name,
        "businessParam": 'img'
      }
      api.upImg({data:data}).then(res => {
        let formData = new FormData();
        formData.append('file',file.file);
        formData.append('token',res.token);
        formData.append('key',res.keyExtend)
        axios.post('https://up-z2.qbox.me', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res =>{
          if(res.error){
            this.$message.error("上传失败，失败原因："+ res.error);
          }else{
            this.picUrl = 'https://img.zberp.net/' + res.data.key;
          }
        })
      })
    },
    handleChange(files, fileList) {
      if (fileList.length > 1) {
        fileList.splice(1, 1);
      }
    },
    uploadQiniu2(file){
      let data = {
        "type": 7,
        "fileName": new Date().getTime() + file.file.name,
        "businessParam": 'img'
      }
      api.upImg({data:data}).then(res => {
        let formData = new FormData();
        formData.append('file',file.file);
        formData.append('token',res.token);
        formData.append('key',res.keyExtend)
        axios.post('https://up-z2.qbox.me', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res =>{
          if(res.error){
            this.$message.error("上传失败，失败原因："+ res.error);
          }else{
            this.commissionImage = 'https://img.zberp.net/' + res.data.key;
          }
        })
      })
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    submitForm(formName){//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this;
          if(this.picUrl){
            this.disabled = true;
            if(_this.title == '创建'){
              this.add();
            }else{
              this.revise();
            }
          }else{
            this.$message.error('请先上传资质证明再创建')
          }
        } else {
          return false;
        }
      });
    },
    add(){//新增
      let data = {
        "picUrl": this.picUrl,
        "signName": this.creatForm.signName,
        "signReason": this.creatForm.signReason,
        "signType": this.creatForm.signType ,
        "usedMethod": this.creatForm.usedMethod ,
        "documentType":this.creatForm.documentType ,
        "commissionImage": this.commissionImage ,
        "enterpriseName":this.creatForm.enterpriseName,
        "signatureType":this.creatForm.signatureType,
        "isPublic":this.creatForm.isPublic
      }
      api.addAutograph({data:data}).then(res => {
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.resetAutographForm('creatAutographForm')
        }else{
          this.disabled = false;
        }
      })
    },
    revise(){//修改
      let data = {
        "picUrl": this.picUrl,
        "signName": this.creatForm.signName,
        "signSign": this.creatForm.signSign,
        "signReason": this.creatForm.signReason,
        "signType": this.creatForm.signType ,
        "usedMethod": this.creatForm.usedMethod ,
        "documentType":this.creatForm.documentType ,
        "commissionImage": this.commissionImage ,
        "enterpriseName":this.creatForm.enterpriseName,
        "signatureType":this.creatForm.signatureType,
        "isPublic":this.creatForm.isPublic
      }
      api.reviseAutograph({data:data}).then(res => {
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.resetAutographForm('creatAutographForm')
        }else{
          this.disabled = false;
        }
      })
    },
    resetAutographForm(formName){//取消
      this.$refs[formName].resetFields();
      this.picUrl = '';
      this.commissionImage = '';
      this.$emit('closeComponent')
    }
  },
  components: {
    
  }
}
</script>
  




// WEBPACK FOOTER //
// src/components/message/creatAutograph.vue